import exclamationTriangle from './triangleExclamation';

export const faExclamationTriangle = exclamationTriangle('classic', 'thin');
export const falExclamationTriangle = exclamationTriangle('classic', 'light');
export const fatExclamationTriangle = exclamationTriangle('classic', 'thin');
export const fadExclamationTriangle = exclamationTriangle('duotone', 'thin');
export const fasExclamationTriangle = exclamationTriangle('classic', 'solid');
export const farExclamationTriangle = exclamationTriangle('classic', 'regular');

export default exclamationTriangle;
